import moment from "moment/moment";

export default function (
  paymentListData,
  paymentAmountField,
  paymentDay,
  paymentMode,
  labelFormat = "DD-MM-YYYY",
  minCol = 12
) {
  const toNumber = (value) => +parseFloat(value || 0).toFixed(2);
  const paymentList = paymentListData || [];
  const labels = [];
  const datasets = [
    {
      label: "COD",
      fill: true,
      borderColor: "#b3b300",
      pointBorderColor: "#b3b300",
      backgroundColor: "#b3b300",
      borderWidth: 3,
      data: [],
    },
    {
      label: "Cashfree",
      fill: true,
      borderColor: "#0040ff",
      pointBorderColor: "#0040ff",
      backgroundColor: "#0040ff",
      borderWidth: 3,
      data: [],
    },
  ];
  if (paymentList && paymentList.length > 0) {
    let lastKnownTime = moment();
    const labelsList = {};
    paymentList.forEach((x) => {
      if (!labelsList[x[paymentDay]]) {
        labelsList[x[paymentDay]] = [0, 0];
        const parsedTime = moment(x[paymentDay], "YYYY-MM-DD");
        if (lastKnownTime.isAfter(parsedTime)) {
          lastKnownTime = parsedTime;
        }
      }
      if (x[paymentMode] === "COD") {
        labelsList[x[paymentDay]][0] = toNumber(x[paymentAmountField]);
      }
      if (x[paymentMode] === "CASHFREE") {
        labelsList[x[paymentDay]][1] = toNumber(x[paymentAmountField]);
      }
    });
    const labelsListKeys = Object.keys(labelsList);
    if (labelsListKeys.length < minCol) {
      Array(minCol - labelsListKeys.length)
        .fill(0)
        .forEach((_, i) => {
          labelsList[
            lastKnownTime.subtract(i + 1, "days").format("YYYY-MM-DD")
          ] = [0, 0];
        });
    }
    Object.keys(labelsList)
      .sort((b, a) => new Date(b) - new Date(a))
      .forEach((x) => {
        labels.push(moment(x, "YYYY-MM-DD").format(labelFormat));
        datasets[0]?.data?.push(labelsList[x][0]);
        datasets[1]?.data?.push(labelsList[x][1]);
      });
  }
  return {
    labels,
    datasets,
  };
}
